<template>
  <div>
    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 mt-5">
      <div v-if="report.user" class="intro-y">
        <ReportBox
          class="zoom-in"
          :title="$t('dashboard.totalCustomer')"
          :item="report.user"
          icon="UsersIcon"
          icon-class="text-theme-10"
        />
      </div>
      <div class="intro-y">
        <ReportBox
          class="zoom-in"
          :title="$t('dashboard.totalCustomerContracted')"
          :item="report.contractUser"
          icon="PenToolIcon"
          icon-class="text-theme-11"
        />
      </div>
      <div class="intro-y">
        <ReportBox
          class="zoom-in"
          :title="$t('dashboard.totalActiveLoan')"
          :item="report.loan"
          icon="LayersIcon"
        />
      </div>
      <div class="intro-y">
        <ReportBox
          class="zoom-in"
          :title="$t('dashboard.totalLoanAmount')"
          :item="report.loanAmount"
          icon="CreditCardIcon"
          icon-class="text-theme-9"
          is-currency
        />
      </div>
      <div class="intro-y">
        <ReportBox
          class="zoom-in"
          :title="$t('dashboard.accountBalance')"
          :item="{ total: report.totalAccount }"
          icon="CreditCardIcon"
          icon-class="text-theme-9"
          is-currency
        />
      </div>
      <div class="intro-y">
        <ReportBox
          class="zoom-in"
          :title="$t('dashboard.totalCustomerCanGetLoan')"
          :item="{ total: report.user?.totalLending || 0 }"
          icon="UsersIcon"
          icon-class="text-theme-9"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ReportBox from '@/components/ui/ReportBox';

export default {
  name: 'Dashboard',

  props: {
    report: Object,
  },

  components: {
    ReportBox,
  },

  computed: {},
};
</script>
